export const environment = {
  production: false,
  keycloak: {
    issuer: 'https://uatauthentication.makeryworld.com/auth/',
    realm: 'Makery',
    clientId: 'makery-webshop-prod',
  },
  serviceUrl: 'https://uatwebshop-api.makeryworld.com/',
  translateUrl:'https://uatwebshop-api.makeryworld.com/download/translations/',
  wsUrl:"https://uatdashboard-api.makeryworld.com/makery-erp-websocket"
};
